<template>
  <div class="h-screen flex print:h-auto">
    <div id="portal_popup" />
    <div id="portal_pricing_info_popup" />
    <component :is="sidebar_component" v-if="show_sidebar" :initial-setup />
    <div class="flex flex-col h-screen w-full" :class="{ 'bg-gray-200 overflow-hidden': show_sidebar }">
      <TopPanel v-if="['/'].includes($route.path)" class="hidden sm:flex border-b" />
      <SiteHeader
        :sidebar-visible="show_sidebar"
        :visualiser_place_page="visualiser_place_page"
        :on-landing-page="onLandingPage"
      >
        <template #header_page_breadcrumb>
          <TopPanel
            v-if="!['/'].includes($route.path)"
            class="hidden xs:flex"
            :class="{ 'text-white': authStore.isPortal }"
          >
            <div class="hidden md:flex">
              <slot name="header_page_breadcrumb" />
            </div>
          </TopPanel>
        </template>
        <template #header_page_title>
          <div class="flex items-center overflow-y-auto">
            <div class="flex items-center shrink-0">
              <slot name="header_page_title" />
            </div>
          </div>
        </template>
        <template #header_page_actions>
          <slot name="header_page_actions">
            <span id="header_page_actions" />
          </slot>
        </template>
        <template #site_header_actions_wrapper>
          <slot name="site_header_actions_wrapper" />
        </template>
      </SiteHeader>
      <div id="sub_menu" class="empty:hidden" />
      <div v-if="show_sidebar" class="overflow-y-auto grow shrink basis-0 flex w-full flex-col">
        <div class="flex w-full flex-col max-w-[1850px] mx-auto grow shrink basis-0">
          <div class="flex flex-col gap-5 p-5 xs:p-10 lg:p-10 grow shrink basis-0 w-full">
            <slot />
            <div id="save" class="border bg-white flex items-center py-3 px-5 xs:px-10 empty:hidden" />
          </div>
        </div>
      </div>
      <slot v-else />
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/pinia/auth'

import SiteHeader from '@/components/shared/nav/SiteHeader.vue'
import TopPanel from '@/components/shared/nav/TopPanel.vue'
import PortalSidebarMenu from '@/components/shared/nav/PortalSidebarMenu.vue'
import TouchBusinessSidebarMenu from '@/components/shared/nav/TouchBusinessSidebarMenu.vue'

export default {
  name: 'TouchLayout',
  components: {
    SiteHeader,
    PortalSidebarMenu,
    TouchBusinessSidebarMenu,
    TopPanel
  },
  props: {
    vendor_settings_layout: {},
    visualiser_place_page: {},
    initialSetup: Boolean
  },
  computed: {
    ...mapStores(useAuthStore),
    showSearch() {
      return this.$route.meta.showSearch === true
    },
    searchPlaceholder() {
      return 'Enter Search'
    },
    sidebar_component() {
      return this.authStore.isPortalUser ? 'PortalSidebarMenu' : 'TouchBusinessSidebarMenu'
    },
    show_sidebar() {
      return this.authStore.loggedIn && !this.authStore.isBrandedModeUser && this.$route.meta.showSidebar !== false
    },
    onLandingPage() {
      return this.$route.name === 'Setup'
    }
  }
}
</script>
